import { render, staticRenderFns } from "./NavbarLeft.vue?vue&type=template&id=4b89e685&"
import script from "./NavbarLeft.vue?vue&type=script&lang=js&"
export * from "./NavbarLeft.vue?vue&type=script&lang=js&"
import style0 from "./NavbarLeft.vue?vue&type=style&index=0&id=4b89e685&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports